import {toast, ToastContainer} from "react-toastify";
import TopAdminBar from "../../components/TopAdminBar";
import React, {useState, useEffect} from "react";
import {request, GET, DELETE, PUT, POST, PATCH} from "../../api/ApiAdapter";
import {Col, Container, Row, InputGroup, FormControl,} from "react-bootstrap";
import "./UsedVehiclesStyle.css";
import {HiRefresh} from "react-icons/hi";
import CircularProgress from '@mui/material/CircularProgress';
import Footer from "../../components/Footer";
import {useHistory} from "react-router-dom";
import Confirm from "../../components/Confirm";

const UsedVehicles = () => {

    const  ZebraBrowserPrintWrapper = require('zebra-browser-print-wrapper');

    const [usedVehicles, setUsedVehicles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordPerPage, setRecordPerPage] = useState(10);
    const [recordPerPageForAll, setRecordPerPageForAll] = useState(50);
    const [totalPages, setTotalPages] = useState();
    const [totalElements, setTotalElements] = useState();
    const [printVehicles, setPrintVehicles] = useState([]);
    const [totalPagesCount, setTotalPagesCount] = useState();
    const [printerDisabled, setPrinterDisabled] = useState(false);
    const [totalCount, setTotalCount] = useState();
    // const [printerList, setPrinterList] = useState([]);
    const [selectedPrinter, setSelectedPrinter] = useState();
    const [confirmMsg, setConfirmMsg] = useState(false);
    const [usedVehiclesMap, setUsedVehiclesMap] = useState(new Map());
    const [printVehiclesMap, setPrintVehiclesMap] =  useState(new Map());
    const [printReadyVehicles, setPrintReadyVehicles] = useState([]);

    const [failedCountArray, setFailedCountArray] = useState([]);
    const [failedElementList, setFailedElementList] = useState([]);

    const history = useHistory();
    const [isSmsQr, setIsSmsQr] = useState(null);

    // Create a new instance of the object
    const browserPrint = new ZebraBrowserPrintWrapper.default();

    const loadIsSmsQrStatus = async () => {
        try {
            let result = await request(`accounts/issmsqr/${localStorage.getItem("accountId")}`, GET);
            if (!result.error) {
                setIsSmsQr(result);
            }
            else {
                console.log("Error");
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push("/page/login");
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    const loadUsedVehicles = async () => {
        try {
            let result = await request('prints?printed=false&allUsed=' + validatePrintTypeForCars(localStorage.getItem('printType')) + '&size=1000', GET);
            if (!result.error) {
                result.content.forEach(element => {
                    if ((element.url !== "" || isSmsQr) && element.mileage > 0) {
                        if (!usedVehiclesMap.has(element.id)){  //For safety trap
                            usedVehiclesMap.set(element.id, element);
                            usedVehicles.push(element);
                        }
                    }
                });
                setUsedVehicles([...usedVehicles]);
            }
            else {
                console.log("Error");
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push("/page/login");
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    const refreshUsedVehicles = () => {
        refreshPage();
    };

    useEffect(() => {
        if (isSmsQr !== null) {
            getAllUsedVehicles();
            loadUsedVehicles();
        }
    }, [isSmsQr]);

    const getAllUsedVehicles = async () =>{
        try {
            let result = await request('prints?printed=false&allUsed=' + validatePrintTypeForCars(localStorage.getItem('printType')) + '&size=1000', GET);
            if (!result.error) {
                result.content.forEach(element => {
                    if ((element.url !== "" || isSmsQr) && element.mileage > 0) {
                        if (!printVehiclesMap.has(element.id)){  //For safety trap
                            printVehiclesMap.set(element.id, element);
                            printVehicles.push(element);
                        }
                    }
                });
                setPrintVehicles([...printVehicles]);
                setPrinterDisabled(true);
                // toast.info("Data loaded for printing");
            }
            else {
                console.log("Error");
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push("/page/login");
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const timeout = (delay) => {
        return new Promise( res => setTimeout(res, delay) );
    }

    useEffect(() => {
        loadIsSmsQrStatus();
    },[]);

    let printerStatus;
    const printLabels = async () => {
        if (selectedPrinter !== undefined) {
            // Set the printer
            await browserPrint.setPrinter(selectedPrinter);
            setPrinterDisabled(false);
            // if (totalCount - 1 === totalPagesCount) {
            if (printVehicles.length !== 0) {
                toast.info("Printing Started");
                console.log("Get printer - ", await browserPrint.getPrinter());
                for (const element of printVehicles) {
                    await timeout(200);
                    // Check printer status
                    printerStatus = await browserPrint.checkPrinterStatus();
                    console.log("Printer Status - ", printerStatus);
                    // Check if the printer is ready
                    if (printerStatus.isReadyToPrint) {
                        browserPrint.print(element.printTemplate);
                        printReadyVehicles.push(element);
                    }
                    else {
                        failedElementList.push(element);
                        // toast.error("Printer - " + printerStatus.errors);
                        setPrinterDisabled(true);
                    }
                    setPrinterDisabled(false);
                }
                let tempLabelLoop = [];
                for (const element of failedElementList) {
                    tempLabelLoop.push(element);
                }
                for (let i = 0; i < 3; i++) {
                    if (tempLabelLoop.length > 0) {
                        let failedListTemp = [];
                        for (const element of tempLabelLoop) {
                            await timeout(200);
                            printerStatus = await browserPrint.checkPrinterStatus();
                            if (printerStatus.isReadyToPrint) {
                                browserPrint.print(element.printTemplate);
                                printReadyVehicles.push(element);
                            } else {
                                if (i === 2) {
                                    toast.error(element.stockNum + " vehicle label failed to print. " + printerStatus.errors);
                                    failedCountArray.push(element);
                                }
                                failedListTemp.push(element);
                                setPrinterDisabled(true);
                            }
                            setFailedElementList(failedListTemp);
                            setPrinterDisabled(false);
                        }
                        tempLabelLoop = [];
                        for (const element of failedListTemp) {
                            tempLabelLoop.push(element);
                        }
                    }
                }
                allLabelsMarkAsPrinted();
            }
            else {
                toast.error("No valid data");
                setPrinterDisabled(true);
            }
        }
        else {
            toast.error("No printer selected");
        }
    }

    const allLabelsMarkAsPrinted = async () => {
        let labels =[];
        printReadyVehicles.forEach(element => {
            labels.push(element.id);
        });
        // if (labels.length > 0) {
            let result = await request("prints/labels/", PUT, labels);
            if (!result.error) {
                if (failedCountArray.length === 0 && printReadyVehicles.length > 0) toast.success("All labels printed successfully.");
                else if (printReadyVehicles.length > 0) toast.success(printReadyVehicles.length + " labels printed successfully and " + failedCountArray.length + " labels failed to print.");
                else toast.error("All labels failed to print.")
                // refreshUsedVehicles();
                loadUsedVehicles();
            } else {
                toast.error(result.error.response.data.message);
            }
        // }
        setPrintReadyVehicles([]);
        setPrinterDisabled(true);
        setFailedCountArray([]);
        setFailedElementList([]);
    }

    const validatePrintTypeForTableHeader = (printType) => {
        if(printType === 'A'){
            return 'All';
        }
        else if(printType === 'U'){
            return 'Used';
        }
        else if(printType === 'N'){
            return 'New';
        }
        else if(printType === 'null'){
            return 'Used';
        }
    }

    const validatePrintTypeForCars = (printType) => {
        if(printType === 'A'){
            return 'U,C,N';
        }
        else if(printType === 'U'){
            return 'U,C';
        }
        else if(printType === 'N'){
            return 'N';
        }
        else if(printType === 'null'){
             return 'U,C';
        }
    }

    useEffect( () => {
        console.log("selectedPrinter - ",JSON.parse(localStorage.getItem('printer')));
        const printerSelect = JSON.parse(localStorage.getItem('printer'));

        if (printerSelect !== null) {
            // toast.success("Printer is selected");
            setSelectedPrinter(printerSelect);
        }
        else {
            toast.error("No printer selected");
        }
    },[])

    // const onInputChange = async (e) => {
        // Set the printer
    //     await browserPrint.setPrinter(printerList[e.target.value]);
    //     console.log("Selector Printer - ", printerList[e.target.value]);
    // }

    // let allPrinters;
    // const getPrintersList = async () =>{
    //     // Select all available printer
    //     allPrinters = await browserPrint.getAvailablePrinters();
    //     setPrinterList(allPrinters);
    //     console.log("Printers List - ", allPrinters);
    //     if(allPrinters.length > 0){
    //         toast.warn("Printers are Loading");
    //     } else{
    //         toast.error("Error: No printers available");
    //     }
    // }

    // useEffect(() => {
    //     getPrintersList();
    // },[])

    //========Printer Setting==========//


    //========Check Print Agent Availability==========//

    const refreshPage =  () => {
        window.location.reload(false);
    }

    const checkAgentAvailability = async () => {
        await browserPrint.getAvailablePrinters().then((res) => {
            localStorage.removeItem('agentNotActive');
            setConfirmMsg(false);
            console.log("Agent not available - ",JSON.parse(localStorage.getItem('agentNotActive')));

        }).catch(error => {
            toast.error("Zebra Browser Print not found");
            localStorage.setItem('agentNotActive', JSON.stringify(true));
            setConfirmMsg(JSON.parse(localStorage.getItem('agentNotActive')));
            console.log("Agent not available - ",JSON.parse(localStorage.getItem('agentNotActive')));
        });
    }

    useEffect(() => {
        checkAgentAvailability();
    }, []);

    //========Check Print Agent Availability==========//


    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='colored'
            />
            <div className="bg-white h-screen">
                <TopAdminBar/>
                <div className="ml-64 top-1 mt-3 left-0 flex items-center overflow-auto">
                    <div className="screenSize">
                        <div><b className="text-lg ml-8 mt-20">Used Vehicles</b></div>
                        <Container className="mr-10 mt-6">
                            <Row>
                                <Col xs={8}></Col>
                                {/*<Col xs={3}>*/}
                                    {/*<form*/}
                                    {/*    method="post"*/}
                                    {/*    action="/instrumentType"*/}
                                    {/*    encType="multipart/form-data"*/}
                                    {/*>*/}
                                    {/*    <div className="col-span-6 sm:col-span-3 flex">*/}
                                    {/*        <label*/}
                                    {/*            htmlFor="role"*/}
                                    {/*            className="block mt-1 text-sm font-medium text-gray-700 pr-4"*/}
                                    {/*        >*/}
                                    {/*            Select Printer*/}
                                    {/*        </label>*/}
                                    {/*        <select*/}
                                    {/*            name="selected_printer"*/}
                                    {/*            id="selected_printer"*/}
                                    {/*            disabled={!printerDisabled}*/}
                                    {/*            onChange={(e) => onInputChange(e)}*/}
                                    {/*            className={!printerDisabled ?*/}
                                    {/*                "outline-none focus:ring-green-500 focus:border-green-500 block shadow-sm sm:text-sm  rounded-md p-2 bg-gray-400 text-gray-700" :*/}
                                    {/*                "outline-none focus:ring-green-500 focus:border-green-500 block shadow-sm sm:text-sm  rounded-md p-2 bg-gray-100 text-gray-700"*/}
                                    {/*                }*/}
                                    {/*        >*/}
                                    {/*            <option disabled selected defaultChecked>*/}
                                    {/*                Choose Printer Here*/}
                                    {/*            </option>*/}
                                    {/*            {printerList ?*/}
                                    {/*                printerList.map((item, key) => {*/}
                                    {/*                        return (*/}
                                    {/*                            <option defaultValue="null" value={key} key={key}>*/}
                                    {/*                                {item.name}*/}
                                    {/*                            </option>*/}
                                    {/*                        );*/}
                                    {/*                    })*/}
                                    {/*                : null*/}
                                    {/*            }*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*</form>*/}
                                {/*</Col>*/}
                                <Col xs={1}>
                                    {
                                        (printerDisabled || printVehicles.length === 0) ?
                                            null :
                                            <div className="text-center">
                                                <CircularProgress size={40} />
                                            </div>
                                    }
                                </Col>
                                <Col xs={2}>
                                    <button
                                        onClick={printLabels}
                                        disabled={!printerDisabled}
                                        className={(printerDisabled && printVehicles.length > 0) ?
                                            "lg:flex items-right justify-end text-lg bg-primary-orange rounded-xl px-2 py-1 ml-8 mt-1" :
                                            "lg:flex items-right justify-end text-lg bg-gray-500 rounded-xl px-2 py-1 ml-8 mt-1"
                                        }
                                    >
                                        Print {localStorage.getItem('printType') === null ? 'Used' : validatePrintTypeForTableHeader(localStorage.getItem('printType'))} Cars
                                    </button>
                                </Col>
                                <Col xs={1}>
                                    <button
                                        onClick={refreshUsedVehicles}
                                        className="lg:flex items-center justify-center text-2xl bg-primary-light-blue rounded-xl p-2"
                                    >
                                        <HiRefresh/>
                                    </button>
                                </Col>
                            </Row>
                        </Container>
                        <div className="container mt-4 px-10 mb-16">
                            <div className="vertical_Table_Scroll">
                                <table className="table table-bordered border-info shadow">
                                    <thead>
                                    <tr className="header">
                                        <th>#</th>
                                        <th>STOCKNUM</th>
                                        <th>VIN</th>
                                        <th>YEAR</th>
                                        <th>MAKE</th>
                                        <th>MODEL</th>
                                        <th>MILEAGE</th>
                                        <th>EXTERIORCOLOUR</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {usedVehicles.length === 0 ?
                                        <tr align="center">
                                            <td colSpan="8">No Record Found</td>
                                        </tr> :
                                        usedVehicles.map(
                                            (usedVehicle, index) => (
                                                <tr key={usedVehicle.id}>
                                                    {/*<td>{(recordPerPage * (currentPage - 1)) + index + 1}</td>*/}
                                                    <td>{index + 1}</td>
                                                    <td>{usedVehicle.stockNum}</td>
                                                    <td>{usedVehicle.vin}</td>
                                                    <td>{usedVehicle.year}</td>
                                                    <td>{usedVehicle.make}</td>
                                                    <td>{usedVehicle.model}</td>
                                                    <td>{usedVehicle.mileage}</td>
                                                    <td>{usedVehicle.exteriorColour}</td>
                                                </tr>
                                            )
                                        )
                                    }
                                    </tbody>
                                </table>
                            </div>
                            {/*<div>*/}
                            {/*    <div style={{float: 'left', fontFamily: 'monospace', color: '#0275d8'}}>*/}
                            {/*        Page {currentPage} of {totalPages}*/}
                            {/*    </div>*/}
                            {/*    <div style={{float: 'right'}}>*/}
                            {/*        <nav aria-label="Page navigation example">*/}
                            {/*            <ul className="pagination">*/}
                            {/*                <button*/}
                            {/*                    className="text-md text-gray-900 gap-2 mr-2 mb-1 px-3  border-1 border-dark"*/}
                            {/*                    disabled={currentPage === 1 ? true : false}*/}
                            {/*                    onClick={showFirstPage}>First*/}
                            {/*                </button>*/}
                            {/*                <button*/}
                            {/*                    className="text-md text-gray-900 gap-2 mr-2 mb-1 px-3 border-1 border-dark"*/}
                            {/*                    disabled={currentPage === 1 ? true : false}*/}
                            {/*                    onClick={showPrevPage}>Previous*/}
                            {/*                </button>*/}
                            {/*                <InputGroup size="sm" className="mr-3 py-1">*/}
                            {/*                    <FormControl*/}
                            {/*                        name="currentPage"*/}
                            {/*                        value={currentPage}*/}
                            {/*                        onChange={changePage}*/}
                            {/*                    />*/}
                            {/*                </InputGroup>*/}
                            {/*                <button*/}
                            {/*                    className="text-md text-gray-900  gap-2 mr-2 mb-1 px-3 border-1 border-dark"*/}
                            {/*                    disabled={currentPage === totalPages ? true : false}*/}
                            {/*                    onClick={showNextPage}>Next*/}
                            {/*                </button>*/}
                            {/*                <button*/}
                            {/*                    className="text-md text-gray-900 gap-2 mr-2 mb-1 px-3 border-1 border-dark"*/}
                            {/*                    disabled={currentPage === totalPages ? true : false}*/}
                            {/*                    onClick={showLastPage}>Last*/}
                            {/*                </button>*/}
                            {/*            </ul>*/}
                            {/*        </nav>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
            {confirmMsg ? (
                <Confirm
                    onConfirm={refreshPage}
                />
            ) : null}
        </>
    );
}

export default UsedVehicles;
